import api from ".";
import { memoizedRefreshToken, removeUserData } from "./refreshToken";
import { isJwtExpired } from "jwt-check-expiration";

api.interceptors.request.use(
  async (config) => {
    const data = JSON.parse(localStorage.getItem("data"));

    if (!config.headers["Authorization"]) {
      if (data) {
        if (isJwtExpired(data.Jwt)) {
          await memoizedRefreshToken();

          setTimeout(() => {
            console.log("refreshing...");
          }, 2000);
        }

        config.headers = {
          Authorization: `Bearer ${data?.Jwt}`,
          company: "oneclick",
          ...config.headers,
        };
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && originalRequest.url.includes("refreshtoken")) {
      removeUserData();
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      return await memoizedRefreshToken();
    }

    return Promise.reject(error.response && error.response.data);
  }
);
